import firebase from "firebase/app";
import "firebase/auth";
import {dateFromFB, createWagonActual} from "./v_utils";
// import moment from "moment";
import i18n from "../i18n";

export default {
    setDrawerState({ state, commit}, payload) {
        if (payload == undefined)
            commit("setDrawerState", !state.drawer);
        else
            commit("setDrawerState", payload);
    },
    signUpUser({ commit }, payload) {
        firebase.auth().createUserWithEmailAndPassword(payload.email, payload.password).then(
            (user) => {
              //console.log("User " + payload.username ? payload.username : payload.email + " Created Successfully !");
                if (payload.username) {
                    user.user.updateProfile({
                        username: payload.username,
                        displayName: payload.username
                    }).then(() => {
                        user => {
                            const newUser = {
                                uid: user.user.uid,
                                name: user.user.displayName
                            }
                            commit("setUser", newUser)
                        }
                    })
                } else {
                    user => {
                        const newUser = {
                            uid: user.user.uid,
                            name: user.user.email
                        }
                        commit("setUser", newUser)
                    }
                }
            },
            (err) => {
                alert("Oops. " + err.message);
            }
        );
    },

    async loginUser({ commit, dispatch }, payload) {
        firebase.auth().signInWithEmailAndPassword(payload.email, payload.password).then(
            function (user) {
                const _user = {
                    uid: user.user.uid,
                    name: user.user.displayName ? user.user.displayName : user.user.email
                }
                firebase.auth().currentUser.getIdTokenResult().then((idTokenResult) => {
                    //cspell: disable
                    //Todo: fix user claim..
                    if (idTokenResult.claims.admin || user.user.uid == "iExew1Pewbh8v0JNEmpRyF3vXAu1")
                        _user._admin_ = true;
                });

                commit("setUser", _user);
                dispatch("loadFeeds");
                dispatch("loadTMRs");
                dispatch("loadGroups");
                dispatch("loadWagons");
                dispatch("loadDashData");
                // dispatch("loadEquipments");
                // dispatch("loadRecipes");
            },
            function (err) {
                //console.log("Oops." + err.message);
                payload.root.$globalSnackbar(i18n.t('Login Fail'), "error" );
                throw new Error(err.message);
            }
        );
    },
    setNewDocNo({state, commit}) {
        let num = Number(state.Profile.nextDocNo);
        if (num && Number.isInteger(num))
            num = num + 1;
        else
            num = 1001;
        commit("updateProfile", { nextDocNo: num });
        return num;
    },
    incrementRecipeNo({state, commit}) {
        let num = Number(state.Profile.nextRecipeNo);
        if (num && Number.isInteger(num))
            num = num + 1;
        else
            num = 101;
        commit("updateProfile", { nextRecipeNo: num });
        return num;
    },
    getUsersList({state}) {
        //TODO: fix permission to allow this for "admin"
        if (state.user._admin_) {
            return firebase.firestore().collection("/Users").get().then(function(snap) {
                    snap.map((d) => {
                        return { text: d.doc.get("name"), value: d.id }
                })
            })
        }
        else
            return [];
    },
    assumeUser({commit, dispatch}, payload) {
        if (payload) {
            commit("assumeUid", payload);
            dispatch("loadFeeds");
            dispatch("loadTMRs");
            dispatch("loadGroups");
            dispatch("loadWagons");
            dispatch("loadDashData");
        }
    },
    saveProfile({commit}, payload) {
        if (payload)
            commit("setProfile", payload);
    },

    logoutUser({ commit }) {
        firebase.auth().signOut().then(function () {
            commit("unsubscribeAllSnaps");
            commit("setUser", null)
        });
    },
    //============== Feeds ================================
    loadFeeds({commit, state}) {
        // Fixme:console.log("loadFeeds...");
        var ref = firebase.firestore().collection("/Users")
                 .doc(state.user.uid).collection("/Feeds");
        //ref.get().then(function (snap) {
        var _unsubscribe = ref.onSnapshot((snap) => {
            var _feeds = [];
            snap.forEach(function (doc) {
               _feeds.push({ Id: doc.id, ...doc.data() });
            })
            commit("setFeeds", _feeds);
        });
        commit("FeedUnsubscribeFunc", _unsubscribe);
    },
    saveFeed({commit, state}, payload) {
        var ref = firebase.firestore().collection("/Users")
                 .doc(state.user.uid).collection("/Feeds");
        var id = payload.Id;
        var feed = payload;
        delete feed.Id;  //remove "id" from object
        feed.feedType ? feed.feedType : "Unspecified";
        const original = state.Feeds.find(f => f.Id === id);
        if (id) {
            ref.doc(id).update(feed);
            if (feed.invQty == 0 && feed.invQty != original.invQty) {
                firebase.firestore().collection("/Users")
                    .doc(state.user.uid).collection("/transactions").add({
                        feedRef: firebase.firestore().collection("/Users")
                            .doc(state.user.uid).collection("/Feeds").doc(id),
                        transQty: original.invQty * -1,
                        transTime: firebase.firestore.Timestamp.now(),
                        refDoc: null,
                        transType: "adjustment",
                        reference: 'RESET_QTY',
                        dryMaterial: original.dryMaterial,
                        feedValue: original.value
                    });
            }
        }
        else {
            ref.doc(feed.code).set(feed);
        }
        commit("updateFeed", payload);
    },
    deleteFeed({commit, state}, payload) {
        var ref = firebase.firestore().collection("/Users")
                 .doc(state.user.uid).collection("/Feeds");
        var id = payload;
        ref.doc(id).delete();
        commit("delFeed", payload);
    },
    stopFeedListener({commit}) {
        commit("FeedUnsubscribeNow");
    },
    //============== TMRs ================================
    loadTMRs({commit,state}) {
       // Fixme:console.log("loadTMRs...")
        var ref = firebase.firestore().collection("/Users")
        .doc(state.user.uid).collection("/tmrs");
        //ref.get().then(function (snap) {
        var _unsubscribe = ref.onSnapshot((snap) => {
            var _tmrs = [];
            snap.forEach(function (doc) {
                var tmr = {
                    Id: doc.id,
                    code: doc.data().code,
                    doseweight: doc.data().doseweight,
                    feeds: doc.data().feeds,
                    inactive: doc.data().inactive,
                    modified: doc.data().modified ? doc.data().modified.toDate() : new Date(),
                    name: doc.data().name,
                    premixkey: doc.data().premixkey,
                    version: doc.data().version
                    };
                    //console.info("TMR:" + tmr.code + " Feeds:\n", tmr.feeds);
                    _tmrs.push(tmr);
                });
            commit("setTMRs", _tmrs);
        });
        commit("TmrsUnsubscribeFunc", _unsubscribe);
    },
    saveTMR({commit, state}, payload) {
        //verify TMR values:
        payload.feeds.forEach((f) => f.qty = Number(f.qty)|| 0);
        payload.feeds.forEach((f) => f.tolerance = Number(f.tolerance) || 0);
        payload.doseweight = payload.feeds.reduce(function (a, f) {
                    return isNaN(Number(f["qty"])) ? a : a + Number(f["qty"]);
                }, 0);
        //add feed ref..
        var feedRef = firebase.firestore().collection("/Users")
            .doc(state.user.uid).collection("/Feeds");

        //convert feed Id to (firbase)reference with key="feed"
        payload.feeds.forEach((f) => {
            if (f.feed === undefined && f.Id)
                f.feed = feedRef.doc(f.Id);
            delete f.Id;
        });

        payload.modified = new Date();
        var ref = firebase.firestore().collection("/Users")
                  .doc(state.user.uid).collection("/tmrs");
        var id = payload.Id;
        var tmr = payload;
        delete tmr.Id;      //remove "id" from object
        if (id) {
            ref.doc(id).update(tmr);
        }
        else {
            ref.doc(tmr.code).set(tmr);
        }
        commit("updateTMR", payload);
    },
    deleteTMR({commit, state}, payload) {
        var ref = firebase.firestore().collection("/Users")
                  .doc(state.user.uid).collection("/tmrs");
        var id = payload;
        ref.doc(id).delete();
        commit("delTMR", payload);
    },
    stopTMRListener({commit}) {
        commit("TMRUnsubscribeNow");
    },
    //============== Groups ================================
    async saveGroup({commit, state}, payload) {
        var ref = firebase.firestore().collection("/Users")
                 .doc(state.user.uid).collection("/Groups");
        var id = payload.Id;
        var group = payload;
        delete group.Id;
        if (id) {
            //store previous group values:
            var needWagonUpdate = await ref.doc(id).get().then(grp => {
                let prevGroup = grp.data();
                return  group.cowCount != prevGroup.cowCount ||
                        group.hungerPercent != prevGroup.hungerPercent ||
                        group.defaultTMR.dailyPercent != prevGroup.defaultTMR.dailyPercent ||
                        group.secondTMR.dailyPercent != prevGroup.secondTMR.dailyPercent ||
                        group.weeklyDelivery.join() != prevGroup.weeklyDelivery.join();
            });
            ref.doc(id).update(group);
        }
        else {
            ref.doc(group.code).set(group);
        }
        commit("updateGroup", payload);
        if (needWagonUpdate) {
          //console.info("wagons update needed!");
            state.Wagons.forEach((w) => {
                if (w.groups.some(function(g) {
                    return g.code == group.code;
                })) {
                    let tmr = state.TMRs.find((t) => t.Id == w.tmr.documentID);
                    commit("updateWagon", { wgn: w, group: group, tmr: tmr });
                }
            });
        }

    },
    deleteGroup({commit, dispatch, state}, payload) {
        var ref = firebase.firestore().collection("/Users")
                 .doc(state.user.uid).collection("/Groups");
        var id = payload;
        let group = state.Groups.find((g) => g.Id == id);
        //update wagons with deleted group
        state.Wagons.forEach((w) => {
            if (w.groups.some(function (g) {return g.code == group.code;})) {
                dispatch("removeGroupFromWagon", { wagonId: w.id, wGroup: group });
            }
        });
        ref.doc(id).delete();
        commit("delGroup", payload);
    },
    loadGroups({commit, state}) {
       // Fixme:console.log("loadGroups...");
        var ref = firebase.firestore().collection("/Users")
                 .doc(state.user.uid).collection("/Groups");
        //ref.get().then(function (snap) {
        var _unsubscribe = ref.onSnapshot((snap) => {
            var _groups = [];
            snap.forEach(function (doc) {
                var grp = {
                    Id: doc.id,
                    code: doc.data().code,
                    name: doc.data().name,
                    active: doc.data().active,
                    groupType: doc.data().groupType,
                    hungerPercent: doc.data().hungerPercent,
                    cowCount: doc.data().cowCount,
                    operNote: doc.data().operNote,
                    defaultTMR: doc.data().defaultTMR || { code:  null, dailyPercent: 100 },
                    secondTMR: doc.data().secondTMR ||  { code:  null, dailyPercent: 0 },
                    weeklyDelivery: doc.data().weeklyDelivery ||  [1, 1, 1, 1, 1, 1, 1]
                    };
                _groups.push(grp);
            });
            commit("setGroups", _groups);
        });
        commit("groupUnsubscribeFunc", _unsubscribe);
    },
    stopGroupeListener({commit}) {
        commit("GroupUnsubscribeNow");
    },

    //============== Wagons ================================
    addGroupToWagon({commit, state}, payload) {
        let wagon = {};
        let group = state.Groups.find((g) => g.Id == payload.groupId);
        let tmr = state.TMRs.find((t) => t.code == payload.tmrCode);

        //Create new Wagon:
        if (payload.wagonId == "ADD") {
            let maxOrder = state.Wagons.reduce((a, w) => w.order > a ? w.order: a, 0);  //get max order
            wagon = {
               lastMade: new Date("2000-01-01T00:00:00"),
               lastMadeId: "",
               lastModified: new Date(),
               name: "W"+ (maxOrder+1).toString(),
               order: maxOrder+1,
               onlyForDays: state.selectedDays,
               tmr: {
                   documentID: tmr.Id,
                   code: tmr.code,
                   ref: firebase.firestore().collection("/Users").doc(state.user.uid)
                                .collection("tmrs").doc(tmr.Id)
               },
               groups: [
                   {
                        code: group.code,
                        dailyPercent: 100,
                        documentID: group.Id,
                        name: group.name,
                        qty: 0
                   }
               ]
            }
        } else {
            wagon =  state.Wagons.find((w) => w.id === payload.wagonId);
            wagon.lastModified = new Date();
            //Add group to existing Wagon:
            wagon.groups.push({
                code: group.code,
                dailyPercent: 50,
                documentID: group.Id,
                name: group.name,
                selectedDays: state.selectedDays,
                qty: 0
            });
        }
        try {
            commit("updateWagon", {wgn: wagon, group: group, tmr:tmr});
            payload.vm.$root.$globalSnackbar(`Group ${group.name} [${group.code}]: added successfully to wagon ${wagon.name} [${wagon.order}]`, "success");
        } catch (e) {
            payload.vm.$root.$globalSnackbar(`Error (adding group ${group.code} to wagon ${wagon.name}): ${e}`, "error");
        }
    },
    removeGroupFromWagon({commit, state}, payload) {
        let wagon =  state.Wagons.find((w) => w.id === payload.wagonId);
        let group = state.Groups.find((g) => g.Id == payload.wGroup.documentID);
        let tmr = state.TMRs.find((t) => t.Id == wagon.tmr.documentID);
        wagon.lastModified = Date();
        let idx = wagon.groups.indexOf(payload.wGroup);
        wagon.groups.splice(idx, 1);
        commit("updateWagon", {wgn: wagon, group: group, tmr:tmr} );
    },
    changeWagonOrder({commit, state}, payload) {
        if (payload.prevOrder && payload.prevOrder < payload.newOrder)
            payload.wagon.order = payload.newOrder + 0.1;
        if (payload.prevOrder && payload.prevOrder > payload.newOrder)
            payload.wagon.order = payload.newOrder - 0.1;
        let _sorted = state.Wagons.sort((a, b) => a.order-b.order);
        _sorted.forEach((w, i) => w.order = (i+1));
        commit("updateWagon", {wgn: payload.wagon });

    },
    saveWagon({commit}, payload) {
        commit("updateWagon", { wgn: payload });
    },
    deleteWagon({commit, state}, payload) {
        var ref = firebase.firestore().collection("/Users")
                  .doc(state.user.uid).collection("/wagons");
        var id = payload;
        ref.doc(id).delete();
        commit("delWagon", payload);
    },
    reloadWagon({ commit, state }, payload) {
        let wagon = state.Wagons.find((w)=> w.id == payload.id);
        if (! wagon) return;
        var ref = firebase.firestore().collection("/Users")
            .doc(state.user.uid).collection("/wagons").doc(payload.id);
        ref.get((doc)=>
            wagon = {
                id: doc.id,
                order: doc.data().order,
                name: doc.data().name,
                onlyForDays: doc.data().onlyForDays || [1, 2, 3, 4, 5, 6, 7],
                lastMade: dateFromFB(doc.data().lastMade, new Date("2000-01-01")),
                lastModified: dateFromFB(doc.data().lastModified, new Date()),
                lastMadeId: doc.data().lastMadeId || "",
                tmr: {
                    documentID: doc.data().tmr.documentID || "",
                    code: doc.data().tmr.code || 0,
                    ref: doc.data().tmr.ref || {}
                },
                groups: doc.data().groups || []
        });
        commit("updateWagon", { wgn: wagon });
    },
    loadWagons({commit, state}) {
       // Fixme:console.log("loadWagons...")
        var ref = firebase.firestore().collection("/Users")
                  .doc(state.user.uid).collection("/wagons");
        //ref.get().then(function (snap) {
        var _unsubscribe = ref.onSnapshot((snap) => {
            var _wagons = [];
            snap.forEach(function (doc) {
                var wgn = {
                    id: doc.id,
                    order: doc.data().order,
                    name: doc.data().name,
                    onlyForDays: doc.data().onlyForDays ||  [1,2,3,4,5,6,7],
                    lastMade: dateFromFB(doc.data().lastMade, new Date("2000-01-01")),
                    lastModified: dateFromFB(doc.data().lastModified, new Date()),
                    lastMadeId: doc.data().lastMadeId || "",
                    tmr: {
                        documentID: doc.data().tmr.documentID || "",
                        code: doc.data().tmr.code || 0,
                        ref: doc.data().tmr.ref || {}
                    },
                    groups: doc.data().groups || []
                    };
                _wagons.push(wgn);
            });
            commit("setWagons", _wagons);
        });
        commit("wagonUnsubscribeFunc", _unsubscribe);
    },
    actionSetSelectedDays({commit}, payload) {
        commit("setSelectedDays", payload);
    },

    //========= Dashboard data ===================
    loadDashData({ commit, state }) {
        const ref = firebase.firestore().collection("/Users")
                        .doc(state.user.uid).collection("/Actuals");

        //Todo: commented for debug restore true TS
        const tsFrom = firebase.firestore.Timestamp.fromDate(new Date(2020, 5, 1));
        const tsTo = firebase.firestore.Timestamp.fromDate(new Date(2020, 5, 15));
        // const tsFrom = firebase.firestore.Timestamp.fromDate(moment().subtract(1, "day").startOf("day").toDate());
        // const tsTo = firebase.firestore.Timestamp.fromDate(moment().endOf("day").toDate());

        var _unsubscribe = ref.orderBy("endTime")
        .startAt(tsFrom)
        .endAt(tsTo)
        .onSnapshot((snap) => {
            //console.debug("DashData: snapshot doc count:", snap.docs.length);
                let _data = [];
                let made = 0;
                let deliv = 0;
                snap.docs.forEach(doc => {
                    const w = doc.data();
                    made = w.loadings.reduce(function (a, b) {
                        return isNaN(Number(b.qty)) ? a : a + Number(b.qty);
                    }, 0);
                    deliv = w.unloadings.reduce(function (a, b) {
                        return isNaN(Number(b.unloadedWeight)) ? a : a + Number(b.unloadedWeight);
                    }, 0);
                    //console.log(`entry: ${w.wagonName} Made: ${made} deliv: ${deliv}`);
                    _data.push({
                        name: w.wagonName,
                        made: made,
                        delivery: deliv,
                        endTime: w.endTime.toDate(),
                        tmrValue: w.tmrValue,
                        tmrDryMaterial: w.tmrDryMaterial,
                        duration: w.duration
                    });
                });
                _data.sort((a,b) => (a.name > b.name) ? 1: -1 );
                commit("setDashData", _data);
            });
        commit("dashUnsubscribeFunc", _unsubscribe);
    },
    //====================== Equipment data =============
    loadEquipments({ commit, state }) {
       // Fixme:console.log("loadEquipments...")
        var _unsubscribe = firebase.firestore().collection("/Users")
            .doc(state.user.uid).collection("/equipment")
            .onSnapshot((snap) => {
                var _data = [];
                snap.docs.forEach((doc) =>
                    _data.push( {...doc.data(), docId: doc.id}))
                if (_data.length == 1 && !('active' in _data[0]))
                    _data["active"] = true;
                commit("setEquipments", _data);
            });
        commit("equipUnsubscribeFunc", _unsubscribe);
    },
    activateEquipment({ commit, state }, index) {
        state.Equipments.forEach((e, indx) => {
            if (indx == index) {
                e.active = true;
                firebase.firestore().collection("/Users").doc(state.user.uid)
                    .collection("/equipment").doc(e.docId).update({active: true});
            }
            else if (e.active) {
                e.active = false;
                firebase.firestore().collection("/Users").doc(state.user.uid)
                    .collection("/equipment").doc(e.docId).update({ active: false });
            }
        });
        commit("setEquipments", [...state.Equipments]);
        const activation = { date: Date.now(), equipment: state.Equipments[index].Id };
        if (!state.Profile.activations)
            state.Profile.activations = [activation];
        else
            state.Profile.activations.push(activation);
        commit("updateProfile", {activations: state.Profile.activations});

    },
    //======================= Inventory Transaction ============
    saveTransaction({ state, dispatch}, data) {
        if (data.feedId && data.transQty ){
            //update feed value and dryMaterial
            const feedId = data.feedId
            const fbTs = (data.transTime) ? firebase.firestore.Timestamp.fromDate(data.transTime)
                                          : firebase.firestore.Timestamp.now();
            const _feed = state.Feeds.find(f => f.Id === data.feedId);
            _feed.dryMaterial = data.dryMaterial > 5 ? data.dryMaterial / 100 : data.dryMaterial;
            _feed.value = data.feedValue;
            dispatch("saveFeed", { ..._feed});
            return firebase.firestore().collection("/Users")
                .doc(state.user.uid).collection("/transactions").add({
                    feedRef: firebase.firestore().collection("/Users")
                        .doc(state.user.uid).collection("/Feeds").doc(feedId),
                    transQty: data.transQty,
                    transTime: fbTs,
                    refDoc: null,
                    transType: data.type || "purchase",
                    seller: data.seller,
                    driver: data.driver,
                    truckNo: data.truckNo,
                    reference: data.reference,
                    dryMaterial: data.dryMaterial > 5 ? data.dryMaterial /100 : data.dryMaterial,
                    feedValue: data.feedValue
                });
        }
    },

    saveManualWagonTrans({state}, data) {
        let promises = [];
        const ts = firebase.firestore.Timestamp.fromDate(new Date(data.prodTime))
        promises.push(createWagonActual(state, data));
        data.feeds.forEach((feed) => {
            promises.push(
                firebase.firestore().collection('/Users').
                    doc(state.user.uid).collection("transactions").add({
                    feedRef: firebase.firestore().collection("/Users")
                        .doc(state.user.uid).collection("/Feeds").doc(feed.Id),
                    transQty: (feed.qty * -1),
                    transTime: ts,
                    refDoc: null,
                    reference: '_MANUAL_PROD_',
                    transType: 'production'
                })
            );
        });
        if (data.toFloor) {
            promises.push(
                firebase.firestore().collection('/Users').
                    doc(state.user.uid).collection("transactions").add({
                        feedRef: firebase.firestore().collection("/Users")
                            .doc(state.user.uid).collection("/tmrs").doc(data.Id),
                        transQty: data.sum,
                        transTime: ts,
                        refDoc: null,
                        reference: '_MANUAL_PROD_',
                        transType: 'production'
                    })
            );
        }
        return Promise.all(promises);
    },
    loadStoredInvCount({ commit, state }) {
        //check if stored table and load it
        const ref = firebase.firestore().collection("/Users")
            .doc(state.user.uid).collection("/invCount").doc('_INV_COUNT_');
        return ref.get().then((doc) => {
            if (doc.exists) {
                commit("setInvCount", doc.data());
                return doc.get('list');
            } else
                return [];
        });
    },
    saveInvCount({ commit, state }, list) {
        commit("setInvCount", { ...state.invCount, list: list });
        firebase.firestore().collection("/Users")
            .doc(state.user.uid).collection("/invCount").doc('_INV_COUNT_')
            .set(state.invCount);
    },

    clearInvCount({ commit, state }) {
        firebase.firestore().collection("/Users")
            .doc(state.user.uid).collection("/invCount").doc('_INV_COUNT_')
            .delete();
        commit("setInvCount", {});
    },
    generateInvCount({ commit, state, dispatch }){
        const docNo = Number(state.Profile.nextDocNo) || 1000;
        dispatch("setNewDocNo");
        commit("setInvCount", {
            time: firebase.firestore.Timestamp.now(),
            countNo: docNo,
            list: [].concat(state.Feeds.map(f => {
                return {
                    feedId: f.Id,
                    tmrId: null,
                    code: f.code,
                    name: f.name,
                    currentCount: f.invQty || 0,
                    newCount: null,
                    use: false,
                    isTmr: false
                };
            }),
                state.TMRs.map(r => {
                    return {
                        feedId: null,
                        tmrId: r.Id,
                        code: r.code,
                        name: r.name,
                        currentCount: r.invQty || 0,
                        newCount: null,
                        use: false,
                        isTmr: true
                    };
                })
            )
        });
        return state.invCount.list;
    },
    applyInvAdjustments({ state, commit }) {
        let affected =  0;
        state.invCount.list.forEach(item => {
            if (item.use) {
                affected += 1;
                let feedRef;
                let dryMat = null;
                let feedValue = null;
                if (item.isTmr) {
                    let _tmr = state.TMRs.find(t => t.Id === item.tmrId);
                    feedRef = firebase.firestore().collection("/Users")
                        .doc(state.user.uid).collection("/tmrs").doc(item.tmrId),
                    _tmr.invQty = _tmr.invQty
                        ? _tmr.invQty + (Number(item.newCount) - Number(item.currentCount))
                        : Number(item.newCount);
                    commit("updateTMR", { ..._tmr });
                } else {
                    let _feed = state.Feeds.find(f => f.Id === item.feedId);
                    feedRef= firebase.firestore().collection("/Users")
                        .doc(state.user.uid).collection("/Feeds").doc(item.feedId),
                    _feed.invQty = _feed.invQty
                        ? _feed.invQty + (Number(item.newCount) - Number(item.currentCount))
                        : Number(item.newCount);
                    dryMat = _feed.dryMaterial;
                    feedValue = _feed.value;
                    commit("updateFeed", {..._feed});
                }
                firebase.firestore().collection("/Users")
                    .doc(state.user.uid).collection("/transactions")
                    .add({
                        feedRef: feedRef,
                        transQty: (item.newCount - item.currentCount),
                        transTime: state.invCount.time,
                        refDoc: null,
                        transType: "adjustment",
                        reference: state.invCount.countNo,
                        dryMaterial: dryMat,
                        feedValue: feedValue
                    });
            }
        });
        return affected;
    },
    //======================= Change Language ============
    changeLanguage({ commit, state }, language) {
        if (!language)
            language = state.Profile.language;
      //console.info('language requested: ' + language);
        if (language) {
            let _locale = state.languages[language];
          //console.info('changing language to: '+ _locale);
            commit("setLanguage", _locale);
        }
    },
    //===================== Recipe data ======================
    loadRecipes({commit, state}) {
       // Fixme:console.log("loadRecipe...")
        var ref = firebase.firestore().collection("/Users")
                 .doc(state.user.uid).collection("/recipes");
        //ref.get().then(function (snap) {
        var _unsubscribe = ref.onSnapshot((snap) => {
            var _recipes = [];
            snap.forEach(function (doc) {
               _recipes.push({ id: doc.id, ...doc.data() });
            })
           // Fixme:console.debug(_recipes);
            commit("setRecipes", _recipes);
        });
        commit("RecipeUnsubscribeFunc", _unsubscribe);
    },
    saveRecipe({commit, state, dispatch}, payload)  {
        var ref = firebase.firestore().collection("/Users")
                 .doc(state.user.uid).collection("/recipes");
        var id = payload.id;
        var recipe = payload;
        delete recipe.id; //remove "id" from object
        if (recipe.code >= state.Profile.nextRecipeNo) {
           // Fixme:console.info(recipe.code, state.Profile.nextRecipeNo)
            dispatch("incrementRecipeNo");
        }
        if (id) {
            ref.doc(id).update(recipe);
        }
        else {
            ref.doc(recipe.code.toString()).set(recipe);
        }
        commit("updateRecipe", payload)
    },
    deleteRecipe({commit, state}, payload) {
        firebase.firestore().collection("/Users")
            .doc(state.user.uid).collection("/recipes")
            .doc(payload).delete();
        commit("delRecipe", payload);
    },
};


